const state = {
    roles: [],
    is_broker: false,
    is_referrer: false,
};

const getters = {
    is_broker: state => {
        return state.is_broker;
    },
    is_referrer: state => {
        return state.is_referrer;
    },
    roles: state => {
        return state.roles;
    },

    // Taken from Summary tab js (07.01.2020)
    // isReferrer: function () {
    //   let roles = this.$store.state.user_roles.roles;
    //   let referrer = roles.find(item => {
    //     if (item.name === "referrer") {
    //       return item;
    //     }
    //   });
    //   return !!referrer;
    // },
};

const mutations = {
    saveRoles(state, roles) {
        state.roles = roles;
    },
    saveIsBroker(state, is_broker) {
        state.is_broker = is_broker;
    },
    saveIsReferrer(state, is_referrer) {
        state.is_referrer = is_referrer;
    }
};

const actions = {
    saveRoles(context, roles) {
        context.commit("saveRoles", roles);
    },
    saveIsBroker(context, is_broker) {
        context.commit("saveIsBroker", is_broker);
    },
    saveIsReferrer(context, is_referrer){
        context.commit('saveIsReferrer', is_referrer);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
